
















import Vue from 'vue'
import BaseLayout from '@/layout/BaseLayout.vue'
import CommonBack from '@/components/Common/CommonBack.vue'
import { mapActions, mapGetters } from 'vuex'
import { CompanyActionTypes } from '@/store/modules/companies'
import { Company } from '@/models/companies'

interface Data {
  company: string
}

interface Method {
  [CompanyActionTypes.Create]: (company: string) => Promise<void>
  createCompany: () => void
}

interface Computed {
  getCompaniesList: Company[]
  cantCreate: boolean
  canCancel: boolean
}

export default Vue.extend<Data, Method, Computed, {}>({
  components: {
    BaseLayout,
    CommonBack,
  },
  data() {
    return {
      company: '',
    }
  },
  computed: {
    ...mapGetters(['getCompaniesList']),
    cantCreate(): boolean {
      return this.company.length === 0
    },
    canCancel(): boolean {
      return this.getCompaniesList.length > 0
    },
  },
  methods: {
    ...mapActions([CompanyActionTypes.Create]),
    createCompany(): void {
      this[CompanyActionTypes.Create](this.company).then(() => {
        this.$router.push('/scripts')
      })
    },
  },
  metaInfo() {
    return { title: this.$tc('company.new') }
  },
})
